import { Injectable } from '@angular/core';

import { BaseReferenceService } from './base';

@Injectable({
  providedIn: 'root',
})
export class TwistDirectionReferenceService extends BaseReferenceService {
  constructor() {
    super('TwistDirectionReference');
  }
}
